import { type FC, useState } from 'react';
import { useSubscription } from '@apollo/client';

import { ChallengeStatus, type ChallengeWithStatus } from '__generated__/GQL';
import { ChallengeConnectedDevicesDocument } from 'features/StrongAuthentication/graphql/subscriptions/challengeConnectedDevices.gql';

import { ChallengeRequest } from './ChallengeRequest';

export const ChallengeRequestListener: FC = () => {
  const { data: subscriptionData } = useSubscription(
    ChallengeConnectedDevicesDocument,
  );

  const [challengeDone, setChallengeDone] = useState<string[]>([]);

  const requestFromSubscription = subscriptionData?.challengeConnectedDevices;

  if (!requestFromSubscription) {
    return null;
  }

  if (challengeDone.includes(requestFromSubscription.challengeId)) {
    return null;
  }

  const pendingChallenge = {
    ...requestFromSubscription,
    status: ChallengeStatus.Pending,
  } as unknown as ChallengeWithStatus;

  return (
    <ChallengeRequest
      challenge={pendingChallenge}
      isOpen={pendingChallenge !== null}
      onClose={() => {
        setChallengeDone([...challengeDone, pendingChallenge.challengeId]);
      }}
    />
  );
};
